export const GET_USER_STATISTICS = 'GET_USER_STATISTICS';
export const GET_USER_STATISTICS_SUCCESS = 'GET_USER_STATISTICS_SUCCESS';
export const GET_SHOP_STATISTICS = 'GET_SHOP_STATISTICS';
export const GET_SHOP_STATISTICS_SUCCESS = 'GET_SHOP_STATISTICS_SUCCESS';
export const GET_STORY_STATISTICS = 'GET_STORY_STATISTICS';
export const GET_STORY_STATISTICS_SUCCESS = 'GET_STORY_STATISTICS_SUCCESS';
